import { FiscalDocument } from '@dreryk/egabinet-invoice-frontend-api';
import { TaxIdentifier } from '@dreryk/tax-identifier-common-api';

import { useFormController } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem, StyledFlex } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../translations';

import { fiscalDocumentTypeVisitor } from './InvoiceCreateForm.utils';
import { InvoiceCreateFormSwitchBean, InvoiceFor } from './InvoiceCreateFormSwitch.types';

const ITEMS: RadioGroupItem<InvoiceFor>[] = [
   {
      id: 'PRIVATE_INDIVIDUAL',
      label: invoiceCreateModalTranslationKeys.forPrivateIndividual,
   },
   {
      id: 'COMPANY',
      label: invoiceCreateModalTranslationKeys.forCompany,
   },
];

type InvoiceCreateFormSwitchRenderProps = {
   invoiceFor: InvoiceFor;
};

type InvoiceCreateFormSwitchProps = {
   readonly children: (renderProps: InvoiceCreateFormSwitchRenderProps) => JSX.Element;
   readonly fiscalDocuments: FiscalDocument[];
   readonly taxIdentifier: TaxIdentifier | undefined;
};

export const InvoiceCreateFormSwitch = (props: InvoiceCreateFormSwitchProps): JSX.Element => {
   const { register, watch } = useFormController<InvoiceCreateFormSwitchBean>({
      invoiceFor: TaxIdentifier.isValid(props.taxIdentifier?.toString())
         ? 'COMPANY'
         : fiscalDocumentTypeVisitor(props.fiscalDocuments)({
              receiptWithTaxIdentifier: () => 'COMPANY',
              receiptWithoutTaxIdentifier: () => 'PRIVATE_INDIVIDUAL',
              noFiscalDocuments: () => 'PRIVATE_INDIVIDUAL',
           }),
   });

   const invoiceFor = watch('invoiceFor');

   return (
      <StyledFlex direction={'column'} gap={32}>
         <RadioGroup
            items={ITEMS}
            testId={'invoiceFor'}
            controller={register('invoiceFor')}
            label={invoiceCreateModalTranslationKeys.invoiceFor}
            horizontal
            disabled={fiscalDocumentTypeVisitor(props.fiscalDocuments)({
               receiptWithTaxIdentifier: () => true,
               receiptWithoutTaxIdentifier: () => true,
               noFiscalDocuments: () => false,
            })}
         />
         {props.children({
            invoiceFor: invoiceFor,
         })}
      </StyledFlex>
   );
};
